module.exports = __webpack_public_path__ + "img/menuLibrary.82ef45e7.svg";